type Theme = {
  accentBackground: string
  accentColor: string
  background0: string
  background025: string
  background05: string
  background075: string
  color1: string
  color2: string
  color3: string
  color4: string
  color5: string
  color6: string
  color7: string
  color8: string
  color9: string
  color10: string
  color11: string
  color12: string
  color0: string
  color025: string
  color05: string
  color075: string
  background: string
  backgroundHover: string
  backgroundPress: string
  backgroundFocus: string
  borderColor: string
  borderColorHover: string
  borderColorPress: string
  borderColorFocus: string
  backgroundStrong: string
  color: string
  colorHover: string
  colorPress: string
  colorFocus: string
  colorTransparent: string
  placeholderColor: string
  outlineColor: string
}

const lightTheme: Theme = {
  accentBackground: '#a5a5a5',
  accentColor: '#00ffa6',
  background0: 'rgba(255, 255, 255,0)',
  background025: 'rgba(255, 255, 255, 0.25)',
  background05: 'rgba(255, 255, 255,0.5)',
  background075: 'rgba(255, 255, 255,0.75)',
  color1: '#fff',
  color2: '#f8f8f8',
  color3: 'hsl(0, 0%, 96.3%)',
  color4: 'hsl(0, 0%, 94.1%)',
  color5: 'hsl(0, 0%, 92.0%)',
  color6: 'hsl(0, 0%, 90.0%)',
  color7: 'hsl(0, 0%, 88.5%)',
  color8: 'hsl(0, 0%, 81.0%)',
  color9: 'hsl(0, 0%, 56.1%)',
  color10: 'hsl(0, 0%, 50.3%)',
  color11: 'hsl(0, 0%, 42.5%)',
  color12: 'hsl(0, 0%, 9.0%)',
  color0: '#000000',
  color025: '#000000',
  color05: '#000000',
  color075: '#000000',
  background: '#f8f8f8',
  backgroundHover: 'hsl(0, 0%, 96.3%)',
  backgroundPress: 'hsl(0, 0%, 94.1%)',
  backgroundFocus: 'hsl(0, 0%, 92.0%)',
  backgroundStrong: '#fff',
  borderColor: 'hsl(0, 0%, 92.0%)',
  borderColorHover: 'hsl(0, 0%, 90.0%)',
  borderColorPress: 'hsl(0, 0%, 92.0%)',
  borderColorFocus: 'hsl(0, 0%, 94.1%)',
  color: 'hsl(0, 0%, 9.0%)',
  colorHover: 'hsl(0, 0%, 42.5%)',
  colorPress: 'hsl(0, 0%, 9.0%)',
  colorFocus: 'hsl(0, 0%, 42.5%)',
  colorTransparent: 'rgba(10,10,10,0)',
  placeholderColor: 'hsl(0, 0%, 56.1%)',
  outlineColor: 'rgba(255,255,255,0.5)',
} as Theme
const darkTheme: Theme = {
  accentBackground: '#a5a5a5',
  accentColor: '#00ffa6',
  background0: 'rgba(21, 21, 21, 0)',
  background025: 'rgba(21, 21, 21, 0.25)',
  background05: 'rgba(21, 21, 21, 0.5)',
  background075: 'rgba(21, 21, 21,0.75)',
  color1: '#050505',
  color2: '#151515',
  color3: '#191919',
  color4: '#232323',
  color5: '#282828',
  color6: '#323232',
  color7: '#424242',
  color8: '#494949',
  color9: '#545454',
  color10: '#626262',
  color11: '#a5a5a5',
  color12: '#fff',
  color0: '#000000',
  color025: '#000000',
  color05: '#000000',
  color075: '#000000',
  background: '#151515',
  backgroundHover: '#191919',
  backgroundPress: '#232323',
  backgroundFocus: '#282828',
  borderColor: '#282828',
  borderColorHover: '#323232',
  borderColorPress: '#000000',
  borderColorFocus: '#282828',
  color: '#fff',
  colorHover: '#a5a5a5',
  colorPress: '#fff',
  colorFocus: '#a5a5a5',
  colorTransparent: 'rgba(255,255,255,0)',
  placeholderColor: '#545454',
  outlineColor: 'rgba(0,0,0,0.5)',
} as Theme

export const light = lightTheme
export const dark = darkTheme
